import "./instrument";
import React from "react";
import ReactDOM from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import {
  ViewerProvider,
  ThemeProvider,
  AlertsProvider,
  i18next,
  ToastContainer,
  DropdownProvider,
  TooltipProvider,
} from "dash-ui";
import App from "App";
import { BulkActionsProvider } from "common/contexts/bulkActionsContext/bulkActionsContext";
import { BreadcrumbProvider } from "common/contexts/breadcrumb-context/breadcrumb-context";

import { client } from "gql/client";
import reportWebVitals from "reportWebVitals";
import "react-toastify/dist/ReactToastify.min.css";

import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ApolloProvider client={client}>
        <ThemeProvider>
          <I18nextProvider i18n={i18next}>
            <ViewerProvider>
              <BreadcrumbProvider>
                <AlertsProvider>
                  <BulkActionsProvider>
                    <DropdownProvider>
                      <TooltipProvider>
                        <>
                          <App />
                          <ToastContainer shiftTop={60} shiftRight={32} />
                        </>
                      </TooltipProvider>
                    </DropdownProvider>
                  </BulkActionsProvider>
                </AlertsProvider>
              </BreadcrumbProvider>
            </ViewerProvider>
          </I18nextProvider>
        </ThemeProvider>
      </ApolloProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
